import React, { useState, useEffect } from 'react';
import { toFixedTrunc } from '../../utils/helper';

const AddOptions = ({
    setSubscriptionPrice,
    subscriptionPrice,
    setPlanName,
    planName,
    status,
    setStatus
}) => {

    const [errors, setErrors] = useState({});

    const handleSubscriptionPriceChange = (e) => {
        setSubscriptionPrice(e.target.value);
    };

    const handlePlanNameChange = (e) => {
        setPlanName(e.target.value);
    };

    const handleAddOptionsChange = (e) => {
        setStatus(e.target.value);
    };

    useEffect(() => {
        if (planName.length > 20) {
            setErrors({
                ...errors,
                plan_name: 'Maximum of 20 characters'
            });
        }

        if (planName.length < 20) {
            setErrors({
                ...errors,
                plan_name: ''
            });
        }
    }, [planName]);

    useEffect(() => {
        if (subscriptionPrice > 0) {
            let price = subscriptionPrice.toString().replace(/^0+/, '');
            price = price.replace(/[\.\%]/g, function (match, offset, all) {
                return match === "." ? (all.indexOf(".") === offset ? '.' : '') : '';
            });
            setSubscriptionPrice(toFixedTrunc(parseFloat(price), 2));
        }
    }, [subscriptionPrice]);


    return <div className="filters__form-add-options">
        <label htmlFor="addOptions" className='filters__form-add-options-label'>Add Options</label>
        <div
            className="form-check"
        >
            <input
                type="radio"
                value="2"
                className="form-check-input"
                id="expired"
                name="addOptions"
                onChange={e => setStatus(e.target.value)}
                checked={status == 2}
            />
            <label className="form-check-label" htmlFor="expired">Expired Status</label>
        </div>
        <div
            className="form-check"
        >
            <input
                type="radio"
                value="0"
                className="form-check-input"
                id="active"
                name="addOptions"
                checked={status == 0}
                onChange={e => setStatus(e.target.value)}
            />
            <label className="form-check-label" htmlFor="expired">Free Subscription</label>
        </div>
        {/* <div
            className="form-check"
        >
            <input
                type="radio"
                value="1-month"
                className="form-check-input"
                id="active"
                name="addOptions"
                checked={status == '1-month'}
                onChange={e => setStatus(e.target.value)}
            />
            <label className="form-check-label" htmlFor="expired">1 Month Subscription</label>
        </div>
        <div
            className="form-check"
        >
            <input
                type="radio"
                value="recurring"
                className="form-check-input"
                id="active"
                name="addOptions"
                checked={status == 'recurring'}
                onChange={e => setStatus(e.target.value)}
            />
            <label className="form-check-label" htmlFor="expired">Recurring Subscription</label>
        </div> */}
        {/* {
            ['1-month', 'recurring'].includes(status) && <div className='form-inline'>
                <div className='form-group my-2'>
                    <label>Subscription Price</label> <input
                        type="number"
                        inputMode="decimal"
                        step="0.01"
                        className="form-control ml-1"
                        style={{ width: 70 }}
                        value={subscriptionPrice}
                        onChange={e => setSubscriptionPrice(e.target.value)}
                        maxLength="5"
                    />
                </div>
                <div className='form-group' style={{ flex: '100%' }}>
                    <label>Subscription Plan Name (20 char max)</label> <input
                        type="text"
                        className="form-control"
                        value={planName}
                        onChange={e => setPlanName(e.target.value)}
                        maxLength="20"
                        style={{ width: 190 }}
                    />

                    {
                        errors.plan_name && <div className='text-danger'>
                            {errors.plan_name}
                        </div>
                    }
                </div>
            </div>
        } */}
    </div>;
};

export default React.memo(AddOptions);